<template>
  <div>
    <div class="query-c" style="display: flex; align-items: center; margin-bottom: 25px">
      查询：
      <Input
        style="width: 200px"
        v-model="parameter.keyword"
        @input="
          parameter.pageNow = 0;
          total = 0;
          getData();
        "
        search
        placeholder="请输入产品名称"
      />
      <div style="display: flex; align-items: center; margin-left: 15px">
        <div style="width: 100px">产品分组:</div>
        <Select
          v-model="parameter.productGroupId"
          @on-change="
            parameter.pageNow = 0;
            total = 0;
            getData();
          "
        >
          <Option value>全部</Option>
          <Option
            v-for="(data, index) in ProductGroupQueryList"
            :key="index"
            :value="data.id"
          >{{ data.name }}</Option>

          <Option :value="0">未分组</Option>
        </Select>
      </div>
      <div style="display: flex; align-items: center; margin-left: 15px">
        <div style="width: 100px">状态:</div>
        <Select
          v-model="parameter.state"
          @on-change="
            parameter.pageNow = 0;
            total = 0;
            getData();
          "
        >
          <Option :value="0">下架</Option>
          <Option :value="1">正常</Option>
        </Select>
      </div>
      <div style="margin-left: 20px">
        <Upload
          style="display: flex"
          :on-format-error="handleFormatError8"
          :on-success="handleSuccess8"
          action="api/v1/replaceUrl/uploadReplaceUrl"
        >
          <Button icon="ios-cloud-upload-outline">上传</Button>
        </Upload>
      </div>
      <Button @click="title='转链';modal1=true;packData={}" style="margin-left:20px">转链</Button>
    </div>

    <Table style="font-size: 20px" border stripe :columns="columns1" :data="data1">
      <template slot="settledStatus" slot-scope="{ row, index }">
        <div v-if="row.settledStatus == 0">订单初始化</div>
        <div v-if="row.settledStatus == 1">初审失败</div>
        <div v-if="row.settledStatus == 2">初审通过</div>
        <div v-if="row.settledStatus == 3">激活成功</div>
        <div v-if="row.settledStatus == 4">已首刷</div>
        <div v-if="row.settledStatus == 5">终审失败</div>
        <div v-if="row.settledStatus == 6">终审成功</div>
        <div v-if="row.settledStatus == 7">已进件</div>
      </template>
      <template slot="isOpenWhitelist" slot-scope="{ row, index }">
        <div v-if="row.isOpenWhitelist == 0">已关闭</div>
        <div v-if="row.isOpenWhitelist == 1">已打开</div>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            modal1 = true;
            title = '修改产品信息';
            UpData = row;
            amend();
          "
        >修改</Button>
        <Button
          style="background: #1e88e5; border-color: #1e88e5;margin-left: 10px"
          type="error"
          size="small"
          @click="
            modal1 = true;
            title = '礼品';
            UpData = row;
            ProductGetGifts();
          "
        >礼品</Button>
        <Button
          style="background: #1e88e5; border-color: #1e88e5; margin-left: 10px"
          type="error"
          size="small"
          @click="
            modal11 = true;
            title = '修改分组';
            UpData = row;
            amend();
          "
        >分组</Button>
        <Button
          style="background: #1e88e5; border-color: #1e88e5; margin-left: 10px"
          type="error"
          size="small"
          @click="
            AddProductLinksParameter = {
              url: '',
              requestData: '',
              weight: '',
              state: '',
              t3rdCode: '',
              requestMethod: '',
              requestHeader: '',
            };
            modal1 = true;
            UpData = row;
            title = '添加产品链接及接口参数';
          "
        >添加产品链接</Button>
        <router-link style="width: 20%" :to="'/ProductUrl?id=' + row.id">
          <Button
            style="
              background: #1e88e5;
              border-color: #1e88e5;
              margin-left: 10px;
            "
            type="error"
            size="small"
          >查看产品链接</Button>
        </router-link>
        <Button
          style="
              background: #1e88e5;
              border-color: #1e88e5;
              margin-left: 10px;  
              margin-top: 10px;
            "
          type="error"
          size="small"
          @click="
            modal1 = true;
          title = '白名单列表';
          totalB = 0;
          UpData = row;
            WhitelistUsers();
          "
        >白名单列表</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-top: 10px;
            margin-left: 10px;
          "
          type="error"
          size="small"
          @click="
            shieldCity = true;
            UpData = row;
            getCity();
          "
        >修改屏蔽城市</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-top: 10px;
            margin-left: 10px;
          "
          type="error"
          size="small"
          @click="
            modal1 = true;
            title = '已绑定用户列表';
            UpData = row;
            QueryBindUsers();
          "
        >已绑定用户列表</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-top: 10px;
            margin-left: 10px;
          "
          type="error"
          size="small"
          @click="
            Delete = true;
            UpData = row;
          "
        >删除</Button>
      </template>
      <template slot-scope="{ row, index }" slot="inputLevel">
        <span v-if="row.inputLevel && row.inputLevel.indexOf('1') != -1">姓名,</span>
        <span v-if="row.inputLevel && row.inputLevel.indexOf('3') != -1">手机号,</span>
        <span v-if="row.inputLevel && row.inputLevel.indexOf('4') != -1">验证码,</span>
        <span v-if="row.inputLevel && row.inputLevel.indexOf('2') != -1">证件号码,</span>
      </template>
      <template slot-scope="{ row, index }" slot="img1">
        <img style="height: 65px; padding: 10px" :src="row.productLogo" />
      </template>
      <template slot-scope="{ row, index }" slot="img2">
        <img style="height: 150px" :src="row.exclusivePosters" />
      </template>
      <template slot-scope="{ row, index }" slot="img3">
        <img style="height: 150px" :src="row.spreadPosters" />
      </template>
    </Table>
    <Modal width="40" v-model="modal2" :title="title">
      <div class="search_list">
        <Input
          v-model="parameter1.name"
          @input="parameter1.pageNow = 1;
            ProductGiftQuery()"
          search
          placeholder="标题"
          style="width: auto;margin-left: 20px;"
        />
      </div>
      <div class="search_list">
        <div class="text">状态:</div>
        <Select
          v-model="parameter1.state"
          @on-change="
            parameter1.pageNow = 1;
            ProductGiftQuery();
          "
          class="select"
        >
          <Option :value="0">下架</Option>
          <Option :value="1">正常</Option>
        </Select>
      </div>
      <Table
        border
        class="table_style"
        :columns="columns3"
        :data="ProductGiftQueryList.list"
        :highlight-row="true"
      >
        <template slot-scope="{ row, index }" slot="img">
          <img style="width: 100px" :src="row.img" alt srcset />
        </template>
        <template slot-scope="{ row, index }" slot="state">
          <div v-if="row.state == 0">下架</div>
          <div v-if="row.state == 1">正常</div>
        </template>
        <template slot-scope="{ row, index }" slot="config">
          <Button @click="ProductAddGifts(row.id)" style="margin-right: 15px" type="primary">添加</Button>
        </template>
      </Table>
    </Modal>
    <Modal width="40" v-model="modal3" title="添加" @on-ok="userIdBAdd()">
      <div>用户:</div>
      <div>
        <Select
          v-model="userIdBAddId"
          filterable
          :remote-method="remoteMethod1"
          :loading="loading1"
        >
          <Option
            v-for="(option, index) in options1"
            :value="option.id"
            :key="index"
          >{{option.username}}({{option.phone}})</Option>
        </Select>
      </div>
    </Modal>
    <Modal width="40" v-model="modal1" :title="title" @on-ok="updated()">
      <div v-if="title == '白名单列表'">
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            modal3 = true;
          "
        >添加</Button>
        <Table
          style="font-size: 20px"
          border
          stripe
          :columns="columns4"
          :data="WhitelistUsersData.list"
        >
          <template slot-scope="{ row, index }" slot="config">
            <Button
              style="background: red; border-color: red"
              type="error"
              size="small"
              @click="DelWhitelist(row.id)"
            >删除</Button>
          </template>
        </Table>
        <Page :total="totalB" @on-change="switchoverB" show-elevator />
      </div>
      <div v-if="title == '转链'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品id:</div>
          <div>
            <Input v-model="packData.productId" placeholder="产品id" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>最终跳转地址:</div>
          <div>
            <Input v-model="packData.url" placeholder="最终跳转地址" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>跳转时间(秒):</div>
          <div>
            <Input v-model="packData.timeout" placeholder="跳转时间" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>引荐源:</div>
          <div>
            <Select v-model="packData.noreferrer">
              <Option :value="0">不屏蔽</Option>
              <Option :value="1">屏蔽</Option>
            </Select>
          </div>
        </div>
      </div>
      <div v-if="title == '礼品'">
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            modal2 = true;
            ProductGiftQuery()
            title1 = '添加';
          "
        >添加</Button>
        <Table style="font-size: 20px" border stripe :columns="columns2" :data="getGiftsData">
          <template slot-scope="{ row, index }" slot="img">
            <img style="width: 100px" :src="row.img" alt srcset />
          </template>
          <template slot-scope="{ row, index }" slot="config">
            <Button
              style="background: red; border-color: red"
              type="error"
              size="small"
              @click="ProductDelGift(row.id)"
            >删除</Button>
          </template>
        </Table>
      </div>
      <div v-if="title == '添加产品链接及接口参数'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>链接地址：</div>
          <div>
            <Input v-model="AddProductLinksParameter.url" placeholder="链接地址：" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>接口请求参数 (json):</div>
          <div>
            <Input v-model="AddProductLinksParameter.requestData" placeholder="接口请求参数" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>三方渠道编码:</div>
          <div>
            <Input v-model="AddProductLinksParameter.t3rdCode" placeholder="三方渠道编码" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>权重:</div>
          <div>
            <Input v-model="AddProductLinksParameter.weight" placeholder="权重" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>请求头:</div>
          <div>
            <Input v-model="AddProductLinksParameter.requestHeader" placeholder="请求头" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>请求方式:</div>
          <div>
            <Input v-model="AddProductLinksParameter.requestMethod" placeholder="请求方式" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态:</div>
          <div>
            <Select
              v-model="AddProductLinksParameter.state"
              style="width: 200px; margin-left: 20px"
              placeholder="选择状态"
            >
              <Option
                v-for="item in AddState"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div v-if="title == '修改产品信息' || title == '添加产品信息'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品名称：</div>
          <div>
            <Input v-model="UpData.productName" placeholder="产品名称" />
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <div>产品Logo：</div>
          <Upload
            :on-success="handleSuccess"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            action="api/v1/product/uploads"
          >
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
          </Upload>
          <img style="width: 100px" :src="UpData.productLogo" alt />
        </div>
        <div style="display: flex; align-items: center">
          <div>专属海报：</div>
          <Upload
            :on-success="handleSuccess1"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            action="api/v1/product/uploads"
          >
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
          </Upload>
          <img style="width: 100px" :src="UpData.exclusivePosters" alt />
        </div>
        <div style="display: flex; align-items: center">
          <div>推广海报：</div>
          <Upload
            :on-success="handleSuccess2"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            action="api/v1/product/uploads"
          >
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
          </Upload>
          <img style="width: 100px" :src="UpData.spreadPosters" alt />
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>奖励金额：</div>
          <div>
            <Input v-model="UpData.rewardAmount" placeholder="奖励金额" />
          </div>
        </div>

        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>降级金额：</div>
          <div>
            <Input v-model="UpData.demotedAmount" placeholder="降级金额" />
          </div>
        </div>

        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>信息收集:</div>
          <div>
            <CheckboxGroup @on-change="ccc" v-model="inputLevelList">
              <Checkbox label="1">姓名</Checkbox>
              <Checkbox label="2">证件号码</Checkbox>
              <Checkbox label="3">手机号</Checkbox>
              <Checkbox label="4">验证码</Checkbox>
            </CheckboxGroup>
          </div>
        </div>

        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品分组:</div>
          <div>
            <Select v-model="UpData.productGroupId">
              <Option
                v-for="(data, index) in ProductGroupQueryList"
                :key="index"
                :value="data.id"
              >{{ data.name }}</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>可见类型:</div>
          <div>
            <Select v-model="UpData.reserve2">
              <Option :value="0">所有人</Option>
              <Option :value="1">发生收益</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>额外金额：</div>
          <div>
            <Input v-model="UpData.extraAmount" placeholder="额外金额" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>结算提示：</div>
          <div>
            <Input v-model="UpData.tips" placeholder="结算提示" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>人工结算状态:</div>
          <div>
            <Select v-model="UpData.settledStatus">
              <Option :value="0">订单初始化</Option>
              <Option :value="1">初审失败</Option>
              <Option :value="2">初审通过</Option>
              <Option :value="3">激活成功</Option>
              <Option :value="4">已首刷</Option>
              <Option :value="5">终审失败</Option>
              <Option :value="6">终审成功</Option>
              <Option :value="7">已进件</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>白名单:</div>
          <div>
            <Select v-model="UpData.isOpenWhitelist">
              <Option :value="0">关闭</Option>
              <Option :value="1">打开</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>有效期：</div>
          <div>
            <Input v-model="UpData.reserve4" placeholder="有效期" />天
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>类型：</div>
          <div>
            <Select v-model="UpData.type1" placeholder="选择类型">
              <Option v-for="item in types" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态：</div>
          <div>
            <Select v-model="UpData.state1" placeholder="选择状态">
              <Option v-for="item in states" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>结算周期：</div>
          <div>
            <Input v-model="UpData.settlementCycle" placeholder="结算周期" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>结算规则：</div>
          <div>
            <Input v-model="UpData.settlementRules" placeholder="结算规则" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>排序：</div>
          <div>
            <Input v-model="UpData.sort" placeholder="排序" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>支持城市:</div>
          <div>
            <div
              v-for="(item, index) in UpData.contentJson"
              :key="index"
              style="width: 400px; float: right; margin-bottom: 10px"
            >
              <Input v-model="item.title" style="width: 150px; margin-right: 15px" />:
              <Input v-model="item.content" style="width: 150px; margin-right: 15px" />
              <Button
                style="background: #2d8cf0; border-color: #2d8cf0; float: right"
                type="error"
                size="small"
                @click="DelSupport(index, UpData.contentJson)"
              >删除</Button>
            </div>
          </div>
        </div>

        <Button
          style="background: #2d8cf0; border-color: #2d8cf0"
          type="error"
          size="small"
          @click="AddSupport(UpData.contentJson)"
        >添加</Button>
      </div>
      <div v-if="title == '已绑定用户列表'">
        <Table style="font-size: 20px" border stripe :columns="columns" :data="QueryBindUsersData">
          <template slot-scope="{ row, index }" slot="config">
            <Button
              style="background: red; border-color: red"
              type="error"
              size="small"
              @click="
                showDelete = true;
                updatedAdd = row;
              "
            >删除</Button>
          </template>
        </Table>

        <Page style="margin-top: 10px" :total="total1" @on-change="pagingSuery1" show-elevator />

        <Button
          style="background: red; border-color: red; margin-top: 15px"
          type="error"
          size="small"
          @click="
            title2 = 'Copy产品用户';
            showadd = true;
            addphone = '';
          "
        >Copy产品用户</Button>
        <Button
          style="
            background: red;
            border-color: red;
            margin-top: 15px;
            margin-left: 15px;
          "
          type="error"
          size="small"
          @click="
            title2 = '添加用户';
            showadd = true;
            addphone = '';
          "
        >添加用户</Button>
        <Button
          style="
            background: red;
            border-color: red;
            margin-top: 15px;
            margin-left: 15px;
          "
          type="error"
          size="small"
          @click="
            title2 = '添加用户组';
            showadd = true;
            addphone = '';
          "
        >添加用户组</Button>
      </div>
    </Modal>
    <Modal v-model="showDelete" title="删除绑定用户" @on-ok="ProductDelBindUser()">
      <div style="width: 100%; text-align: center">删除绑定用户</div>
    </Modal>
    <Modal v-model="modal11" :title="title" @on-ok="updated()">
      <div style="display: flex; align-items: center">
        <div style="width: 100px">产品分组:</div>
        <Select v-model="UpData.productGroupId">
          <Option
            v-for="(data, index) in ProductGroupQueryList"
            :key="index"
            :value="data.id"
          >{{ data.name }}</Option>
        </Select>
      </div>
    </Modal>
    <Modal @on-ok="ProductBindUser()" v-model="showadd" :title="title2">
      <div v-if="title2 == 'Copy产品用户'">
        产品id：
        <Input v-model="copyProductId" type="number" style="width: auto; margin-right: 15px" />
      </div>
      <div v-if="title2 == '添加用户'">
        用户手机号：
        <Input v-model="addphone" style="width: auto; margin-right: 15px" />
      </div>
      <div v-if="title2 == '添加用户组'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>用户组：</div>
          <div>
            <Select v-model="userGroupId" placeholder="选择用户组">
              <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
        </div>
      </div>
    </Modal>
    <Modal width="40" v-model="shieldCity" title="添加修改屏蔽城市">
      <Tree @on-check-change="ConfigCity" ref="tree" :data="treeData" show-checkbox></Tree>
    </Modal>
    <Modal v-model="Delete" title="删除产品信息" @on-ok="DelProduct()">
      <div style="width: 100%; text-align: center">是否删除产品信息！</div>
    </Modal>
    <Button
      style="
        background: #2d8cf0;
        border-color: #2d8cf0;
        float: right;
        padding: 8px 30px;
        font-size: 20px;
      "
      type="error"
      size="small"
      @click="
        modal1 = true;
        title = '添加产品信息';
        UpData = { sort: 50, type: 1, state: 1 };
      "
    >添加产品信息</Button>
    <Page :total="total" @on-change="switchover" show-elevator />
  </div>
</template>
<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      title1: "",
      totalB: 0,
      modal11: false,
      addphone: "",
      packData: {},
      copyProductId: "",
      showadd: false,
      userGroupId: "",
      Delete: false,
      modal2: false,
      modal3: false,
      title2: "",
      updatedAdd: {},
      showDelete: false,
      shieldCity: false,
      options1: [],
      AddProductLinksParameter: {
        url: "",
        requestData: "",
        weight: "",
        state: "",
        t3rdCode: "",
        requestMethod: "",
        requestHeader: ""
      },
      columns3: [
        {
          title: "标题",
          className: "fontcolor",
          align: "center",
          key: "name"
        },
        {
          title: "图片",
          align: "center",
          className: "fontcolor",
          slot: "img"
        },
        {
          title: "状态",
          align: "center",
          slot: "state",
          className: "fontcolor"
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right"
        }
      ],
      loading1: false,
      columns4: [
        {
          title: "用户名",
          className: "fontcolor",
          align: "center",
          key: "username"
        },
        {
          title: "用户手机号",
          className: "fontcolor",
          align: "center",
          key: "phone"
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right"
        }
      ],
      AddState: [
        {
          value: "0",
          label: "未使用"
        },
        {
          value: "1",
          label: "使用"
        }
      ],
      inputLevelList: [],
      ProductGroupQueryList: [],
      total: 0,
      total1: 0,
      parameter: {
        pageNow: 1,
        pageSize: 10
      },
      parameter1: {
        pageNow: 1,
        pageSize: 999
      },
      states: [
        {
          value: 0,
          label: "下架"
        },
        {
          value: 1,
          label: "正常"
        },
        {
          value: 2,
          label: "接口正常"
        }
      ],
      types: [
        {
          value: 1,
          label: "链接"
        },
        {
          value: 2,
          label: "接口"
        }
      ],
      modal1: false,
      title: "",
      data1: [{}],

      WhitelistUsersData: { list: [] },
      QueryBindUsersData: [],
      ProductGiftQueryList: [],
      pageNow1: 0,
      rowCity: {},
      AllCity: {},
      SupportData: [],
      treeData: [],
      UpData: {},
      getGiftsData: [],
      columns2: [
        {
          title: "id",
          align: "center",
          key: "id"
        },
        {
          title: "标题",
          align: "center",
          key: "name"
        },
        {
          title: "图片",
          align: "center",
          width: "150px",
          slot: "img"
        },
        {
          title: "操作",
          align: "center",
          width: "150px",
          slot: "config"
        }
      ],
      columns1: [
        {
          title: "id",
          align: "center",
          key: "id",
          width: 100
        },
        {
          title: "产品名称",
          align: "center",
          key: "productName",
          width: 200
        },
        {
          title: "产品分组",
          align: "center",
          key: "groupName",
          width: 200
        },

        {
          title: "产品Logo",
          align: "center",
          width: "150px",
          slot: "img1",
          key: "productLogo",
          width: 100
        },
        {
          title: "信息收集",
          className: "fontcolor",
          align: "center",
          slot: "inputLevel",
          width: 200
        },
        {
          title: "奖励金额",
          align: "center",
          key: "rewardAmount",
          width: 100
        },

        {
          title: "降级金额",
          align: "center",
          key: "demotedAmount",
          width: 100
        },
        {
          title: "额外金额",
          align: "center",
          key: "extraAmount",
          width: 100
        },
        {
          title: "结算提示",
          align: "center",
          key: "tips",
          width: 200
        },
        {
          title: "人工结算状态",
          align: "center",
          slot: "settledStatus",
          width: 200
        },
        {
          title: "白名单",
          align: "center",
          slot: "isOpenWhitelist",
          width: 200
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          width: 100
        },
        {
          title: "状态",
          key: "state",
          align: "center",
          width: 100
        },
        {
          title: "结算周期",
          align: "center",
          key: "settlementCycle",
          width: 150
        },
        {
          title: "结算规则",
          align: "center",
          key: "settlementRules",
          width: 150
        },
        {
          title: "操作",
          align: "center",
          width: "150px",
          slot: "action",
          width: 400,
          fixed: "right"
        }
      ],
      userList: [],
      userIdBAddId: "",
      columns: [
        {
          title: "用户id",
          align: "center",
          key: "id"
        },
        {
          title: "手机号",
          align: "center",
          key: "phone"
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          width: "150px",
          slot: "config"
        }
      ]
    };
  },
  mounted: function() {
    api
      .ProductGroupQueryList({
        pageNow: 1,
        pageSize: 999999
      })
      .then(res => {
        this.ProductGroupQueryList = res.body.data.list;
      });
    this.getData();
    api
      .UserGroupQueryList({
        pageNow: 1,
        pageSize: 999999
      })
      .then(res => {
        this.userList = res.body.data.list;
      });
  },

  activated() {
    api
      .UserGroupQueryList({
        pageNow: 1,
        pageSize: 999999
      })
      .then(res => {
        this.userList = res.body.data.list;
      });
  },
  methods: {
    ProductGiftQuery() {
      this.parameter1.productId = this.UpData.id;
      api.ProductGiftQueryList(this.parameter1).then(res => {
        this.ProductGiftQueryList = res.body.data;
      });
    },
    ProductDelGift(id) {
      api.ProductDelGift(this.UpData.id, id).then(res => {
        alert(res.body.message);
        this.ProductGetGifts();
      });
    },
    ProductAddGifts(id) {
      api
        .ProductAddGifts({
          productId: this.UpData.id,
          giftIds: [id]
        })
        .then(res => {
          alert(res.body.message);
          this.ProductGiftQuery();
          this.ProductGetGifts();
        });
    },
    ProductGetGifts() {
      api.ProductGetGifts(this.UpData.id).then(res => {
        this.getGiftsData = res.body.data;
      });
    },
    handleFormatError8(file) {
      alert(file.name);
    },
    handleSuccess8(res, file) {
      alert(res.message);
    },
    DelProduct() {
      api.DelProduct({ id: this.UpData.id }).then(res => {
        alert(res.body.message);
        this.getData();
      });
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading1 = true;
        api
          .UserList({
            pageNow: 1,
            pageSize: 10,
            keyword: query
          })
          .then(res => {
            this.loading1 = false;
            this.options1 = res.body.data.list;
          });
      } else {
        this.options1 = [];
      }
    },
    ProductDelBindUser() {
      api
        .ProductDelBindUser({
          id: this.UpData.id,
          userId: this.updatedAdd.id
        })
        .then(res => {
          alert(res.body.message);
          this.QueryBindUsers();
        });
    },
    QueryBindUsers() {
      api
        .QueryBindUsers({
          pageNow: this.pageNow1,
          pageSize: "10",
          id: this.UpData.id
        })
        .then(res => {
          this.total1 = res.body.data.total;
          this.QueryBindUsersData = res.body.data.list;
        });
    },
    ProductBindUser() {
      if (this.title2 == "Copy产品用户") {
        api.ProductCopyBind(this.copyProductId, this.UpData.id).then(res => {
          this.QueryBindUsers();
          if (res.body.status == 1) {
            alert(res.body.message);
          }
        });
      }

      if (this.title2 == "添加用户") {
        api
          .ProductBindUser({
            id: this.UpData.id,
            phone: this.addphone
          })
          .then(res => {
            this.QueryBindUsers();
            if (res.body.status == 1) {
              alert(res.body.message);
            }
          });
      }
      if (this.title2 == "添加用户组") {
        api
          .ProductBindUser({
            id: this.UpData.id,
            userGroupId: this.userGroupId
          })
          .then(res => {
            this.QueryBindUsers();
            if (res.body.status == 1) {
              alert(res.body.message);
            }
          });
      }
    },
    WhitelistUsers() {
      api
        .WhitelistUsers({ productId: this.UpData.id, pageNow: 1 })
        .then(res => {
          this.WhitelistUsersData = res.body.data;
        });
    },
    DelWhitelist(id) {
      api.DelWhitelist({ id: id }).then(res => {
        this.$Message.info(res.body.message);
        this.WhitelistUsers();
      });
    },
    userIdBAdd() {
      api
        .AddWhitelist({ productId: this.UpData.id, userId: this.userIdBAddId })
        .then(res => {
          this.$Message.info(res.body.message);
          this.WhitelistUsers();
        });
    },
    ConfigCity(res, index) {
      if (index.checked) {
        api
          .AddScreening({
            productId: this.UpData.id,
            cityName: index.province,
            cityGbCode: index.provinceidone
          })
          .then(res => {});
      } else {
        this.rowCity.body.data.list.forEach(element => {
          if (index.province == element.areaName) {
            api.DelScreening({ id: index.selectId }).then(res => {});
          } else {
            this.formatting(
              this.AllCity.body.data,
              this.rowCity.body.data.list
            );
            this.treeData = this.AllCity.body.data;
            index.checked = false;
          }
        });
      }
    },
    async getCity() {
      this.rowCity = await api.SelectAllScreening({
        pageSize: "9999",
        productId: this.UpData.id
      });
      this.AllCity = await api.GetProvincesAll();
      if (!this.rowCity.body.data) {
        this.rowCity.body.data = {};
      }
      this.formatting(this.AllCity.body.data, this.rowCity.body.data.list);
      this.treeData = this.AllCity.body.data;
    },
    updated() {
      if (this.title == "修改产品信息") {
        let data = this.UpData;
        this.UpData.inputLevel = "";
        if (this.UpData.inputLevelList) {
          this.UpData.inputLevelList.forEach(element => {
            this.UpData.inputLevel = this.UpData.inputLevel + element + ",";
          });
        }

        this.UpData.inputLevel = this.UpData.inputLevel.slice(
          0,
          this.UpData.inputLevel.length - 1
        );
        data.rewardAmount = data.rewardAmount * 100;
        data.demotedAmount = data.demotedAmount * 100;
        data.extraAmount = data.extraAmount * 100;
        data.content = JSON.stringify(data.contentJson);
        data.state = data.state1;
        data.type = data.type1;
        this.$forceUpdate();
        api.UpdateProduct(data).then(res => {
          this.getData();
        });
      } else if (this.title == "添加产品信息") {
        this.UpData.rewardAmount = this.UpData.rewardAmount1 * 100;
        this.UpData.demotedAmount = this.UpData.demotedAmount1 * 100;
        this.UpData.extraAmount = this.UpData.extraAmount1 * 100;
        this.UpData.content = JSON.stringify(this.UpData.contentJson);
        this.UpData.inputLevel = "";
        if (this.UpData.inputLevelList) {
          this.UpData.inputLevelList.forEach(element => {
            this.UpData.inputLevel = this.UpData.inputLevel + element + ",";
          });
        }

        this.UpData.inputLevel = this.UpData.inputLevel.slice(
          0,
          this.UpData.inputLevel.length - 1
        );
        this.$forceUpdate();
        api.AddProduct(this.UpData).then(res => {
          this.getData();
        });
      } else if (this.title == "添加产品链接及接口参数") {
        this.AddProductLinksParameter.productId = this.UpData.id;
        api.AddProductUrl(this.AddProductLinksParameter).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      } else if (this.title == "修改分组") {
        api
          .UpdateProduct({
            id: this.UpData.id,
            productGroupId: this.UpData.productGroupId
          })
          .then(res => {
            this.$layer.alert(res.body.message);
            this.getData();
          });
      } else if (this.title == "转链") {
        api.ProductPack(this.packData).then(res => {
          this.$layer.alert(res.body.data);
          this.getData();
        });
      }
    },
    AddSupport(data) {
      if (data) {
        data.push({ title: "", content: "" });
      } else {
        this.UpData.contentJson = [];
        this.UpData.contentJson.push({ title: "", content: "" });
        this.SupportData.push({ title: "", content: "" });
      }
      this.$forceUpdate();
    },
    DelSupport(index, data) {
      if (data) {
        data.splice(index, 1);
      } else {
        this.SupportData.splice(index, 1);
      }
      this.$forceUpdate();
    },
    ccc() {
      this.UpData.inputLevelList = this.inputLevelList;
    },
    handleSuccess(res, file) {
      this.UpData.productLogo = res.data[0].path;
      this.$forceUpdate();
    },
    handleSuccess1(res, file) {
      this.UpData.exclusivePosters = res.data[0].path;
      this.$forceUpdate();
    },
    handleSuccess2(res, file) {
      this.UpData.spreadPosters = res.data[0].path;
      this.$forceUpdate();
    },
    formatting(AllCity, rowCity) {
      AllCity.forEach(element => {
        if (element.cities) {
          element.children = element.cities;
          this.formatting(element.children, rowCity);
        }
        if (rowCity) {
          rowCity.forEach(rowElement => {
            if (element.province == rowElement.areaName) {
              element.checked = true;
              element.selectId = rowElement.id;
            }
          });
        }
        element.title = element.province;
      });
    },
    amend() {
      api.GetIdProduct(this.UpData.id).then(res => {
        if (res.body.data.content) {
          res.body.data.contentJson = JSON.parse(res.body.data.content);
        } else {
          res.body.data.contentJson = [];
        }
        res.body.data.rewardAmount = res.body.data.rewardAmount / 100;
        res.body.data.demotedAmount = res.body.data.demotedAmount / 100;
        res.body.data.extraAmount = res.body.data.extraAmount / 100;
        res.body.data.state1 = res.body.data.state;
        res.body.data.type1 = res.body.data.type;

        if (res.body.data.state === 0) {
          res.body.data.state = "下架";
        }
        if (res.body.data.state == 1) {
          res.body.data.state = "正常";
        }
        if (res.body.data.state == 2) {
          res.body.data.state = "接口正常";
        }
        if (res.body.data.type === 1) {
          res.body.data.type = "链接";
        } else {
          res.body.data.type = "接口";
        }
        this.UpData = res.body.data;
        if (this.UpData.inputLevel) {
          this.UpData.inputLevelList = this.UpData.inputLevel.split(",");
          this.inputLevelList = this.UpData.inputLevelList;
        }

        this.$forceUpdate();
      });
    },
    getData() {
      api.GetAllProduct(this.parameter).then(res => {
        if (res.body.data) {
          this.total = res.body.data.total;
          this.data1 = res.body.data.list;
          this.data1.forEach(element => {
            if (element.content) {
              element.contentJson = JSON.parse(element.content);
            } else {
              element.contentJson = [];
            }
            element.rewardAmount = element.rewardAmount / 100;
            element.demotedAmount = element.demotedAmount / 100;
            element.extraAmount = element.extraAmount / 100;

            if (element.state === 0) {
              element.state = "下架";
            }
            if (element.state == 1) {
              element.state = "正常";
            }
            if (element.state == 2) {
              element.state = "接口正常";
            }
            if (element.type === 1) {
              element.type = "链接";
            } else {
              element.type = "接口";
            }
          });
          for (let i = 0; i < this.data1.length; i++) {
            if (this.data1[i].inputLevel) {
              this.data1[i].inputLevelList = this.data1[i].inputLevel.split(
                ","
              );
            }
          }
          this.$forceUpdate();
        } else {
          this.total = 0;
          this.data1 = [{}];
        }
      });
    },
    pagingSuery1(pageNow) {
      this.pageNow1 = pageNow;
      this.QueryBindUsers();
    },
    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },
    switchoverB(pageNow) {
      this.WhitelistUsers({ productId: this.UpData.id, pageNow: pageNow });
    }
  }
};
</script>

<style scoped>
</style>